import * as React from "react";
const SvgIconTriangleDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 6L8 10L12 6H4Z", fill: "currentColor" }));
export default SvgIconTriangleDown;
